import Login from "../../components/Login";

const LoginContainer = (props) => <Login setIsLoggedIn {...props}/>;
export default LoginContainer;
